<template>
  <section id="all-orders-listing" class="all-cases-view">
    <div class="container-default">
      <div class="listings-navbar">
        <el-row gutter="20">
          <el-col :lg="12">
            <ul class="d-flex list-items-group-15 barcode-print">
              <li>
                <div class="form-element input-with-icon search-input-lg">
                  <el-input ref="orderInput" placeholder="Order Id / Patient Name" v-model="search_string"
                    @input="getAutoCompleteOrders()" :clearable="true"></el-input>
                  <span>
                    <img src="@/assets/images/icons/search-icon-with-bg-red.svg" alt="icon" class="img-fluid icon" />
                  </span>
                </div>
              </li>
            </ul>
          </el-col>
          <el-col :lg="12">
            <ul class="d-flex  justify-content-end list-items-group-15">
              <li>
                <el-button
                  class="btn button-with-icon"
                  @click="onReportsExport"
                >
                  <span class="mr-8">
                    <img
                      src="@/assets/images/icons/export-icon-with-bg-blue.svg"
                      alt="icon"
                      class="inactive"
                    />
                    <img
                      src="@/assets/images/icons/export-icon-white.svg"
                      alt="icon"
                      class="active"
                    />
                  </span>
                  <span>Export</span>
                </el-button>
              </li>
              <li>
                <div class="form-element search-with-filter-input-without-icon">
                  <el-select v-model="searchBy" clearable filterable default-first-option :reserve-keyword="false"
                    placeholder="Select Search" @change="clearInputSearch">
                    <el-option v-for="item in searchOptions" :key="item.value" :label="item.label"
                      :value="item.value" />
                  </el-select>
                </div>
              </li>
              <li v-if="searchBy == 'Patient DOB'">
                <div class="search-with-date-input">
                  <el-date-picker
                    ref="patientDOBInput"
                    format="MM-DD-YYYY"
                    v-model="date_of_birth"
                    :disabled-date="disabledDate"
                    @change="fetchAllOrders()"
                    placeholder="Select DOB"
                    :clearable="true"
                  ></el-date-picker>
                </div>
              </li>
              <li v-else-if="searchBy == 'hospital'">
                <div class="form-element search-with-filter-input">
                  <el-select v-model="selectedHospital" placeholder="Select Ordering Facility" filterable clearable
                    default-first-option value-key="_id" @change="onHospitalChange" remote @focus="onHospitalFocus" :remote-method="remoteMethodFacility"
                    :loading="hospitalsLoading">
                    <el-option v-for="hospital in hospitalsData.data" :key="hospital" :label="hospital.name"
                      :value="hospital">
                    </el-option>
                  </el-select>
                  <span class="search-icon">
                    <img src="@/assets/images/icons/search-icon-with-bg-red.svg" alt="icon" class="img-fluid" />
                  </span>
                </div>
              </li>
              <li v-else-if="searchBy == 'ordering_physician'">
                <div class="form-element search-with-filter-input">
                  <el-select v-model="physician" placeholder="Select" filterable clearable default-first-option
                    @change="handleCurrentChange(1)" :loading="physiciansLoading" remote
                    :remote-method="remoteMethodPhysician">
                    <el-option v-for="physician in physiciansData.data" :key="physician" :label="`${physician?.first_name || ''} ${physician?.last_name || ''}`.trim()"
                      :value="physician._id">
                    </el-option>
                  </el-select>
                  <span class="search-icon">
                    <img src="@/assets/images/icons/search-icon-with-bg-red.svg" alt="icon" class="img-fluid" />
                  </span>
                </div>
              </li>
            </ul>
          </el-col>
        </el-row>
      </div>
    </div>
    <div class="container-default" style="padding-top: 0">
      <!-- Web Version -->
      <div class="primary-content-view-new" v-loading="loading">
        <div class="listings listings__table listings__all-cases">
          <el-table :data="getAllOrders.data" height="calc(100vh - 200px)" :default-sort="{
            prop: orderBy,
            order: orderType == 'asc' ? 'ascending' : 'descending',
          }" @sort-change="onChangeSort" @selection-change="handleSelectionChange($event)">
            <el-table-column type="selection" width="40" class="selection-check"></el-table-column>
            <el-table-column label="ORDER ID" prop="order_id" width="250" sortable="custom" fixed="left">
              <template #default="scope">
                <div id="name-accession">
                  <span class="order-files ml-5">
                    <img src="@/assets/images/orders-table-file.svg" alt="icon" />
                  </span>
                  <span id="accession-id" @click="goToOrdersView(scope.row._id)" class="cursor ml-5">
                    {{ scope.row.order_id }}
                  </span>
                </div>
                <div v-if="(scope.row.is_stat && !showStatCase())" style="width: 41px; color: #1B2459 ; font-weight: 600; margin-left :15px">
                  STAT</div>
              </template>
            </el-table-column>
            <el-table-column label="PATIENT NAME" prop="patient_info.first_name" min-width="160" sortable="custom"
              fixed="left">
              <template #default="scope">
                <el-button placement="top" class="title-on-hover"
                  :title="convertToUppercase(getPatientNameByInfo(scope.row.patient_info))" @click="
                    copyTitle(getPatientNameByInfo(scope.row.patient_info))
                    ">
                  <span class="text-center ordering_facility-value">{{
                    convertToUppercase(getPatientNameByInfo(scope.row.patient_info))
                    }}</span>
                </el-button>
              </template>
            </el-table-column>
            <el-table-column label="Patient DOB" prop="date_of_birth" min-width="100">
              <template #default="scope">
                <div style="cursor: default;">
                {{ formatDate(scope.row.patient_info.date_of_birth) }}
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="hospitals" label="ORDERING FACILITIES" min-width="200">
              <template #default="scope">
                <el-button placement="top" class="title-on-hover"
                  :title="scope.row.hospital ? scope.row.hospital.name : '--'">
                  <span class="text-center ordering_facility-value">{{
                    scope.row.hospital ? scope.row.hospital.name : "--"
                    }}</span>
                </el-button>
              </template>
            </el-table-column>
            <el-table-column prop="physican" label="physician" min-width="150">
              <template #default="scope">
                <el-button placement="top" class="title-on-hover" :title="scope.row.physician
                    ? scope.row.physician.first_name + ' ' + scope.row.physician.last_name
                    : '--'
                  ">
                  <span class="ordering_physician-value">{{
                    scope.row.physician
                      ? scope.row.physician.first_name + ' ' + scope.row.physician.last_name
                      : "--"
                  }}</span>
                </el-button>
              </template>
            </el-table-column>
            <el-table-column label="CREATED ON" min-width="130" prop="created_at" sortable="custom">
              <template #default="scope">
                <div v-if="scope.row.created_at" class="d-flex">
                  <div style="cursor: default;" class="date pr-10">
                    {{ momentWithTimezone(scope.row.created_at, "MM-DD-yyyy", scope.row.timezone) }}
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="Status" min-width="140" prop="status" sortable="custom">
              <template #default="scope">
                <div class="column-status" v-if="
                  hasPermission('orders', 'pending_rejection') &&
                  scope.row.status
                ">
                  <div>
                    <el-tag :type="getStatusType(scope.row.status)" style="cursor: not-allowed">
                      <span v-if="scope.row.status == 'COMPLETE'">
                        FINALIZED
                      </span>
                      <span v-else-if="scope.row.status == 'PARTIAL'">
                        PARTIAL
                      </span>
                      <span v-else>
                        {{ scope.row.status.split("_").join(" ") }}
                      </span>
                    </el-tag>
                  </div>
                </div>
                <div v-else class="column-status">
                  <el-tag :type="getStatusType(scope.row.status)">
                    {{
                      scope.row.status === "COMPLETE"
                        ? "FINALIZED"
                        : scope.row.status.split("_").join(" ")
                    }}
                  </el-tag>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="accession_id" label="ACCESSION ID" min-width="280" sortable="custom" width="280">
              <template #default="scope">
                <div class="name-accession cursor" v-if="
                  scope.row.accession_data && scope.row.accession_data.length
                ">
                  <span id="accession-id-blue" class="order-accession"
                    v-for="(acccession, index) in scope.row.accession_data" :key="index"
                    @click="goToCaseView(acccession.case_id)">
                    {{ acccession.accession_id }}
                  </span>
                </div>
                <div class="name-accession cursor" @click="goToCaseView(scope.row.case_id)"
                  v-else-if="scope.row.case_id">
                  <span id="accession-id-blue" class="order-accession">
                    {{ scope.row.accession_id }}
                  </span>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="action" label="Actions" width="150" fixed="right">
              <template v-slot="scope">
                <ul class="listings__action-buttons">
                  <li @click="goToOrdersView(scope.row._id)">
                    <el-button class="view-button" title="View Order">
                      <img class="action-active" src="@/assets/images/icons/actions/view-icon.svg" alt="icon" />
                      <img class="action-inactive" src="@/assets/images/icons/actions/view-inactive.svg" alt="icon" />
                    </el-button>
                  </li>
                </ul>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="listings listings__pagination">
          <el-pagination v-model:currentPage="page" v-model:page-size="pageSize" :page-sizes="[25, 50, 75, 100]"
            layout="prev, pager, next, jumper, sizes, total" :total="getAllOrders.total" @size-change="handleSizeChange"
            @current-change="handleCurrentChange" />
        </div>
      </div>
    </div>
    <ExportOrders
      v-if="exportReportsDialogVisisble"
      v-on:close="exportReportsDialogVisisble = false"
      :selected_search_hospital="hospital ? [hospital] : []"
      :selected_search_string="search_string"
      :selected_search_ordering_physician="physician"
      :selected_case_type="caseType"
      :selected_dob="date_of_birth"
      :search_case_status="selectedStatuses"
    >
    </ExportOrders>
  </section>
</template>

<script>
import { defineAsyncComponent } from "vue";
import { mapGetters } from "vuex";
import moment from "moment";
const ExportOrders = defineAsyncComponent(() =>
  import("@/components/orders/ExportOrders")
);
import caseConstants from "@/config/constants/caseConstants";
import {
  ordersExtraSearchOptions,
} from "@/config/constants/searchConstants";
import UserPermissionsHelper from "@/mixins/UserPermissionsHelper";
import FilterHelper from "@/mixins/FilterHelper";
import caseDataHelper from "@/mixins/caseDataHelper";
export default {
  name: "",
  components: {
    ExportOrders,
  },
  props: {
    selectedStatuses: {
      default: [],
    },
  },
  mixins: [FilterHelper, UserPermissionsHelper, caseDataHelper],
  data() {
    return {
      marketerData: [],
      scrollPosition: null,
      marketingManagerData: [],
      userLoading: false,
      disabledDate: (time) => {
        return time.getTime() > Date.now();
      },
      archivePopup: false,
      page: 1,
      pageSize: 25,
      caseType: "",
      caseTypeMap: caseConstants.CASE_TYPE_MAP,
      caseTypes: caseConstants.CASE_TYPES_DATA,
      searchOptions: ordersExtraSearchOptions,
      loading: false,
      search_string: "",
      hospital: "",
      selectedHospital: null,
      date_of_birth: "",
      physician: "",
      searchBy: "",
      orderBy: "",
      orderType: "",
      exportReportsDialogVisisble: false,
      hospitalsData: { data: [] },
      physiciansData: {},
      hospitalsLoading: false,
      physiciansLoading: false,
    };
  },
  created() {
    this.searchOptions = this.searchOptions.filter((option) => option.active);
  },
  computed: {
    getStatusType() {
      return (statusVal) => {
        const status = statusVal;
        if (status == "ACTIVE") {
          return "default";
        } else if (status == "COMPLETE") {
          return "success";
        } else if (status == "TEST_REPORTS") {
          return "warning";
        } else if (status == "PARTIAL") {
          return "info";
        } else if (status == "ARCHIVED") {
          return "danger";
        } else if (status == "REJECTED") {
          return "darkDanger";
        } else if (status == "PENDING") {
          return "danger";
        } else {
          return "";
        }
      };
    },
    ...mapGetters("orders", [
      "getAllOrders",
    ]),
    ...mapGetters("hospitals", ["getAllHospitals"]),
    ...mapGetters("physicians", ["getAllPhysicians"]),
    ...mapGetters("auth", [
      "getUserPrimaryLabId",
    ]),
  },
  async mounted() {
    this.setQueryParamsData();
    await this.fetchAllOrders();
  },
  beforeUnmount() {
    // Clean up the event listener when the component is destroyed
    document.removeEventListener("click", this.focusInput.bind(this));
  },
  beforeUnmount() {
    localStorage.removeItem("searchQueryFacility");
    localStorage.removeItem("searchQueryPhysician");
  },
  methods: {
    async remoteMethodFacility(query) {
      if (query !== "") {
        localStorage.setItem("searchQueryFacility", query);
        await this.fetchAllHospitals(query);
      } else {
        this.hospitalsData.data = [];
      }
    },
    onHospitalFocus() {
      this.hospitalsData.data = [];
    },
    onHospitalChange(value) {
      this.hospital = value && value._id ? value._id : "";
      this.handleCurrentChange(1);
    },
    async remoteMethodPhysician(query) {
      if (query !== "") {
        localStorage.setItem("searchQueryPhysician", query);
        await this.fetchAllPhysicians(query);
      }
    },
    handleSelectionChange(rows) {
      if (rows) {
        this.selectedCaseIds = [];
        this.bulkValidationData = [];
        for (let caseData of rows) {
          this.selectedCaseIds.push(caseData._id);
          this.bulkValidationData.push(caseData);
        }
      } else {
        this.selectedCaseIds = [];
        this.bulkValidationData = [];
      }
    },
    async updateScroll() {
      this.scrollPosition = window.scrollY;
    },
    clearInputSearch() {
      if (
        this.hospital ||
        this.physician ||
        this.date_of_birth ||
        this.search_string 
      ) {
        this.hospital = "";
        this.selectedHospital = null;
        this.hospitalsData.data = [];
        this.physician = "";
        this.date_of_birth = "";
        this.search_string = "";
        this.page = 1;
        this.fetchAllOrders(1);
      }
    },
    async fetchAllPhysicians(physician) {
      try {
        this.physiciansLoading = true;
        let params = {
          limit: 25,
        };
        if (physician) {
          params.search_string = physician;
        }
        await this.$store.dispatch("physicians/fetchAllPhysicians", params);
        this.physiciansData = JSON.parse(JSON.stringify(this.getAllPhysicians));
        this.physiciansLoading = false;
      } catch (error) {
        console.log(error);
      }
    },
    async fetchAllHospitals(hospital) {
      try {
        this.hospitalsLoading = true;
        let params = {
          limit: 25,
        };
        if (hospital) {
          params.search_string = hospital;
        }
        await this.$store.dispatch("hospitals/fetchAllHospitals", params);
        this.hospitalsData = JSON.parse(JSON.stringify(this.getAllHospitals));
        this.hospitalsLoading = false;
      } catch (error) {
        console.log(error);
      }
    },
    setQueryParamsData() {
      this.page = this.$route.query.selectedOrderPage
        ? parseInt(this.$route.query.selectedOrderPage)
        : 1;
      this.pageSize = this.$route.query.selectedOrderPageSize
        ? parseInt(this.$route.query.selectedOrderPageSize)
        : 25;        
      if (this.$route.query.selectedOrderString) {
        this.search_string = this.$route.query.selectedOrderString;
      }
      if (this.$route.query.selectedOrderSearchBy) {
        this.searchBy = this.$route.query.selectedOrderSearchBy;
      }
      if (this.$route.query.selectedOrderPhysician) {
        const savedQuery = localStorage.getItem("searchQueryPhysician");
        if (
          savedQuery &&
          this.$route.query.selectedOrderString !== savedQuery
        ) {
          this.fetchAllPhysicians(savedQuery);
        }
        this.physician = this.$route.query.selectedOrderPhysician;
      }
      if (this.$route.query.selectedOrderHospital) {
        const savedQuery = localStorage.getItem("searchQueryFacility");
        if (savedQuery && this.$route.query.selectedString !== savedQuery) {
          this.fetchAllHospitals(savedQuery);
        }
        this.hospital = this.$route.query.selectedOrderHospital;
        const restoredName = this.$route.query.selectedOrderHospitalName || "";
        if (this.hospitalsData && Array.isArray(this.hospitalsData.data)) {
          const found = this.hospitalsData.data.find((h) => h._id === this.hospital);
          this.selectedHospital = found || (this.hospital ? { _id: this.hospital, name: restoredName } : null);
          if (!found && this.selectedHospital) {
            this.hospitalsData.data = [...this.hospitalsData.data, this.selectedHospital];
          }
        } else {
          this.selectedHospital = this.hospital ? { _id: this.hospital, name: restoredName } : null;
        }
      }
      if (this.$route.query.selectedOrderDateOfBirth) {
        this.date_of_birth = this.$route.query.selectedOrderDateOfBirth;
      }
      if (this.$route.query.selectedOrderOrderBy) {
        this.orderBy = this.$route.query.selectedOrderOrderBy;
      }
      if (this.$route.query.selectedOrderOrderType) {
        this.orderType = this.$route.query.selectedOrderOrderType;
      }
    },
    prepareParams() {
      const params = {
        page: this.page,
        limit: this.pageSize,
      };
      if (this.search_string) {
        params.search_string = this.search_string;
      }
      if (this.date_of_birth) {
        const date_of_birth = moment(this.date_of_birth).format("YYYY-MM-DD");

        params.date_of_birth = date_of_birth;
      }
      if (this.hospital) {
        params.hospital = this.hospital;
      }
      if (this.caseType) {
        params.case_type = this.caseType;
      }
      if (this.physician) {
        params.ordering_physician = this.physician;
      }
      if (this.orderBy && this.orderType) {
        params.order_by = this.orderBy;
        params.order_type = this.orderType;
      }
      if (this.selectedStatuses && this.selectedStatuses.length) {
        params.status = this.selectedStatuses[0];
      }
      return params;
    },
    updateQueryParams(params) {
      let selectedParams = {
        selectedOrderPage: params.page,
        selectedOrderHospital: params.hospital,
        selectedOrderHospitalName:
          (this.selectedHospital && this.selectedHospital.name) ||
          (this.hospitalsData && this.hospitalsData.data
            ? (this.hospitalsData.data.find((h) => h._id === params.hospital) || {}).name
            : undefined),
        selectedOrderDateOfBirth: params.date_of_birth,
        selectedOrderPhysician: params.ordering_physician,
        selectedOrderString: params.search_string,
        selectedOrderPageSize: params.limit,
        selectedOrderOrderBy: params.order_by,
        selectedOrderOrderType: params.order_type,
        selectedStatus: params.status,
        selectedOrderSearchBy: this.searchBy || undefined,
      };
      this.updateQueryParam(this.$route.name, selectedParams);
    },
    handleSizeChange(size) {
      this.pageSize = size;
      this.page = 1;
      this.fetchAllOrders();
    },
    handleCurrentChange(page) {
      this.page = page;
      this.fetchAllOrders();
    },
    onChangeSort({ order, prop }) {
      if (order && prop) {
        this.orderBy = prop;
        this.orderType = order == "ascending" ? "asc" : "desc";
      } else {
        this.orderBy = "";
        this.orderType = "";
      }
      this.fetchAllOrders();
    },
    getAutoCompleteOrders() {
      setTimeout(() => {
        this.page = 1;
        this.fetchAllOrders();
      }, 600);
    },
    async onReportsExport() {
      this.exportReportsDialogVisisble = true;
    },
    async fetchAllOrders() {
      try {
        this.loading = true;
        let params = this.prepareParams();
        if (this.getUserPrimaryLabId) {
          params.lab = this.getUserPrimaryLabId;
        }
        await this.$store.dispatch("orders/getOrders", params);
        this.updateQueryParams(params);
        this.loading = false;
      } catch (error) {
        this.loading = false;
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    goToOrdersView(orderId) {
      this.$router.push({
        name: "Order-Information",
        params: { order_id: orderId },
        query: {
          ...this.$route.query,
          testInfo: undefined,
          address: undefined,
          insurance: undefined,
          redirectRoute: this.$route.name,
        },
      });
    },
    goToCaseView(case_id) {
      this.$router.push({
        name: "CaseView",
        params: { case_id: case_id },
        query: { ...this.$route.query, redirectRoute: this.$route.name },
      });
    },
  },
};
</script>

<style lang="scss">
#all-orders-listing {
  .image-fluid {
    width: 100%;
  }

  .order-files {
    img {
      position: relative;
      top: 3px;
      right: 4px;
    }
  }

  .stickyNavbar {
    padding-bottom: 5px !important;

    .container-default {
      padding-top: 0;
    }
  }

  .listings__table {
    .name-accession {
      display: inline-block;
      overflow: hidden;
      width: 100%;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    #accession-id {
      color: #eb5757;
      cursor: pointer;
    }

    #patient-name {
      overflow: hidden;
      margin-left: 7px;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}

.validation-button {
  display: block;
  margin-bottom: -5px;

  img {
    width: 25px;
  }
}

.reorder-radio {
  .el-radio-group {
    display: grid !important;
    grid-template-columns: 1fr 1fr !important;

    .el-radio__input .el-radio__inner {
      border-color: transparent;
      box-shadow: 0 0 0 1px #ced1d6;
    }

    .el-radio__input.is-checked .el-radio__inner {
      background-color: #0a5da6;
      border-color: #ffffff;
    }

    .el-radio__input.is-checked+.el-radio__label {
      color: #0a5da6;
    }
  }
}

.center-dropdown {
  text-align: center;

  li {
    padding: 0px 15px;
  }
}

.active-button {
  background: #273480 !important;
  color: #fff;
  font-size: 13px;
  padding: 2px 5px !important;

  &:focus,
  &:hover {
    color: #fff !important;
  }
}
.phlebio-radio {
  .el-radio-group {
    display: flex;

    .el-radio__input .el-radio__inner {
      border-color: transparent;
      box-shadow: 0 0 0 1px #ced1d6;
    }

    .el-radio__input.is-checked .el-radio__inner {
      background-color: #0a5da6;
      border-color: #ffffff;
    }

    .el-radio__input.is-checked+.el-radio__label {
      color: #0a5da6;
    }
  }
}
.phlebio-inputs {
  display: grid;
  grid-template-columns: 1fr 1fr;
  column-gap: 20px;
  row-gap: 10px;
  padding-top: 0.5rem;

  .el-input__inner {
    margin-top: 5px;
    background: #ffffff;
    border: 0.719521px solid #56ccf2;
    box-sizing: border-box;
    border-radius: 2px;
    height: 35px;
  }

  .name {
    height: 30px;
    color: #000000;
  }
}
</style>
